import {useEffect} from 'react';
import useStore from './use-store';

const useDevices = () => {
    const {store} = useStore();

    useEffect(() => {
        store.devices.loadDevices();
    }, []);

    return {devices: store.devices};
};

export default useDevices;
